export default "__VITE_ASSET__Bs42mXpK__"